export const MAX_PAGE_SIZE = 100

export const EFFECTIVE_DATE_VALID_AFTER = 0
export const EFFECTIVE_DATE_VALID_BEFORE = 30

export const SKIP_CHECK_IDENTIFICATION_NUMBERS = ['79592']

export const PRODUCTS_WITH_INSTALLMENTS = ['casco', 'property']

export const ENABLE_GENERATE_OFFER = false
